import {api} from "../../../services/api/api.service";

export const loadStats = (id, loading) => api({uri: `/events/${id}/stats`, loading});
export const loadEvent = (id, loading) => api({uri: `/events/${id}`, loading});


